import { actions } from './action'

const initialState = {
  clientsWithEmployees: [], // for all clients
  clientsWithEmpById: [], // for single client
  totalCount: 0, // pagination total
  loading: false,
  error: null,
}

const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_CLIENTS_WITH_EMPLOYEES:
      return {
        ...state,
        clientsWithEmployees: action.payload.data || [],
        totalCount: action.payload.totalCount || 0,
        loading: false,
        error: null,
      }
    case actions.GET_CLIENT_WITH_EMPLOYEES_BY_ID:
      return {
        ...state,
        clientsWithEmpById: action.payload.data || [],
        totalCount: action.payload.totalCount || 0,
        loading: false,
        error: null,
      }
    case actions.GET_CLIENTS_WITH_EMPLOYEES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default clientReducer
